/* Component-specific styles only */
:host {
  display: block;
}
.qr-container {
  text-align: center;
  padding: var(--padding-xxl);
  background: var(--color-bg-secondary);
  border-radius: var(--border-radius);
  margin-bottom: var(--margin-l);
}
.qr-code {
  display: inline-block;
  padding: var(--padding-xl);
  background: var(--color-bg-primary);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
}
.qr-code img {
  display: block;
  width: 200px;
  height: 200px;
}
.url-display {
  margin-top: var(--margin-xl);
  padding: var(--padding-l);
  background: var(--color-bg-primary);
  border: var(--border);
  border-radius: var(--border-radius);
  font-family: monospace;
  font-size: var(--font-size-l);
  word-break: break-all;
}
.info {
  font-size: var(--font-size-s);
  color: var(--color-text-secondary);
  text-align: center;
  margin-top: var(--margin-xl);
}
@media (max-width: 768px) {
  .qr-container {
    padding: var(--padding-xl);
  }
  .qr-code {
    padding: var(--padding-l);
  }
  .qr-code img {
    width: 180px;
    height: 180px;
  }
  .url-display {
    padding: var(--padding);
    font-size: var(--font-size);
  }
}
